import AboutMe from "../../components/applications/about/aboutMe.about";
import ContactMe from "../../components/applications/about/contactMe.about";
import Education from "../../components/applications/about/education.about";
import Experience from "../../components/applications/about/experience.about";
import Projects from "../../components/applications/about/projects.about";
import Resume from "../../components/applications/about/resume.about";
import Skills from "../../components/applications/about/skills.about";
import Chrome from "../../components/applications/chrome.application";
import JIOSaavn from "../../components/applications/jiosaavn.application";
import Mail from "../../components/applications/mail.application";
import SpreadsheetApp from "../../components/applications/spreadsheet.application";
import VSCode from "../../components/applications/vscode.application";
import Word from "../../components/applications/document.application";
import Art from "../../components/applications/art.application";
import Meme from "../../components/applications/meme.application";
import Profile from "../../components/applications/profile.application";
import Screener from "../../components/applications/screener.application";
import Dextool from "../../components/applications/dextool.application";
import Telegram from "../../components/applications/telegram.application";
import Twitter from "../../components/applications/twitter.application";
import Pinterest from "../../components/applications/pinterest.application";
import aboutMe from "../../assets/images/apps/aboutMe.png";
import chrome from "../../assets/images/apps/chrome.png";
import jioSaavn from "../../assets/images/apps/jioSaavn.png";
import music from "../../assets/images/apps/music.png";
import art from "../../assets/images/apps/art.png";
import meme from "../../assets/images/apps/meme.png";
import profile from "../../assets/images/apps/pfp.png";
import screener from "../../assets/images/social/screener.png";
import dextool from "../../assets/images/social/dextool.png";
import telegram from "../../assets/images/social/telegram.png";
import twitter from "../../assets/images/social/x.png";
import pinterest from "../../assets/images/social/pinterest.png";
import mail from "../../assets/images/apps/mail.png";
import word from "../../assets/images/apps/word.png";
import spreadsheet from "../../assets/images/apps/spreadsheet.png";
import vsCode from "../../assets/images/apps/vsCode.png";
import settings from "../../assets/images/apps/settings.png";
import BackgroundSettings from "../../components/applications/settings/background.settings";

const appConfig = [
	{
		id: "aboutMe",
		name: "About Us",
		order: 1,
		icon: aboutMe,
		isSocial: false,
		socialLink: "",
		showInDesktop: true,
		isApplication: false,
		showLinks: true,
		subComponent: [
			{
				name: "About Us",
				component: AboutMe,
			},
			{
				name: "WhitePaper",
				component: Resume,
			},
			{
				name: "Contact Us",
				component: ContactMe,
			},
		],
	},
	{
		id: "art",
		name: "Art",
		order: 2,
		icon: art,
		isSocial: false,
		socialLink: "",
		isApplication: true,
		showInDesktop: true,
		showLinks: true,
		subComponent: [
			{
				name: "art",
				component: Art,
			},
		],
	},
	{
		id: "mail",
		name: "Contact",
		order: 3,
		icon: mail,
		isSocial: false,
		socialLink: "",
		isApplication: true,
		showInDesktop: true,
		showLinks: true,
		subComponent: [
			{
				name: "mail",
				component: Mail,
			},
		],
	},
	{
		id: "screener",
		name: "DEXscreener",
		order: 4,
		icon: screener,
		isSocial: true,
		socialLink: "https://dexscreener.com/solana/3tep1n7tgr9rauv11zjmd7gq27tdgquynu3mcsvf9ze1",
		isApplication: true,
		showInDesktop: true,
		showLinks: true,
		subComponent: [
			{
				name: "screener",
				component: Screener,
			},
		],
	},
	{
		id: "dextool",
		name: "DEXtool",
		order: 5,
		icon: dextool,
		isSocial: true,
		socialLink: "https://www.dextools.io/app/en/solana/pair-explorer/3Tep1n7tGR9RauV11zJMd7gQ27TDgqUynU3mCSVf9zE1?t=1734775742376",
		isApplication: true,
		showInDesktop: true,
		showLinks: true,
		subComponent: [
			{
				name: "dextool",
				component: Dextool,
			},
		],
	},
	{
		id: "telegram",
		name: "Telegram",
		order: 6,
		icon: telegram,
		isSocial: true,
		socialLink: "https://t.me/cult6900world",
		isApplication: true,
		showInDesktop: true,
		showLinks: true,
		subComponent: [
			{
				name: "telegram",
				component: Telegram,
			},
		],
	},
	{
		id: "twitter",
		name: "TwitterX",
		order: 7,
		icon: twitter,
		isSocial: true,
		socialLink: "https://x.com/cult6900world",
		isApplication: true,
		showInDesktop: true,
		showLinks: true,
		subComponent: [
			{
				name: "twitter",
				component: Twitter,
			},
		],
	},
	{
		id: "pinterest",
		name: "Pinterest",
		order: 8,
		icon: pinterest,
		isSocial: true,
		socialLink: "https://pinterest.com/churchofmeme",
		isApplication: true,
		showInDesktop: true,
		showLinks: true,
		subComponent: [
			{
				name: "pinterest",
				component: Pinterest,
			},
		],
	},
	{
		id: "meme",
		name: "Meme",
		order: 9,
		icon: meme,
		isSocial: false,
		socialLink: "",
		isApplication: true,
		showInDesktop: true,
		showLinks: true,
		subComponent: [
			{
				name: "meme",
				component: Meme,
			},
		],
	},
	{
		id: "profile",
		name: "Profile",
		order: 9,
		icon: profile,
		isSocial: false,
		socialLink: "",
		isApplication: true,
		showInDesktop: true,
		showLinks: true,
		subComponent: [
			{
				name: "profile",
				component: Profile,
			},
		],
	},
	{
		id: "jioSaavn",
		name: "Music",
		order: 9,
		icon: music,
		isSocial: false,
		socialLink: "",
		isApplication: true,
		showInDesktop: true,
		showLinks: true,
		subComponent: [
			{
				name: "music",
				component: JIOSaavn,
			},
		],
	},
	{
		id: "chrome",
		name: "Chrome",
		order: 10,
		icon: chrome,
		isSocial: false,
		socialLink: "",
		isApplication: true,
		showInDesktop: true,
		showLinks: true,
		subComponent: [
			{
				name: "chrome",
				component: Chrome,
			},
		],
	},
	{
		id: "word",
		name: "Word",
		order: 11,
		icon: word,
		isSocial: false,
		socialLink: "",
		isApplication: true,
		showInDesktop: true,
		showLinks: true,
		subComponent: [
			{
				name: "word",
				component: Word,
			},
		],
	},
	{
		id: "spreadsheet",
		name: "Spreadsheet",
		order: 12,
		icon: spreadsheet,
		isSocial: false,
		socialLink: "",
		isApplication: true,
		showInDesktop: true,
		showLinks: true,
		subComponent: [
			{
				name: "spreedsheet",
				component: SpreadsheetApp,
			},
		],
	},
	{
		id: "settings",
		name: "Settings",
		order: 13,
		icon: settings,
		isSocial: false,
		socialLink: "",
		showInDesktop: false,
		isApplication: false,
		showLinks: true,
		subComponent: [
			{
				name: "Background",
				component: BackgroundSettings,
			},
		],
	},
];

export default appConfig;
